<template>

        <v-alert
                dense
                type="error"
                class="elevation-8"
                prominent
                v-t="'auth.invalidToken'"
        />


</template>

<script>
    export default {
        name: "RecoveryInvalidToken"
    }
</script>

<style scoped>

</style>